module.exports = __webpack_public_path__ + "0a8371dca89a4b652fd57a79374ae549.png";